import { graphql } from '@/gql';

graphql(`
  fragment HomeServiceOrderProviderPaymentFragment on HomeServiceOrderProviderPaymentType {
    id
    homeServiceOrderId
    homeServiceProviderId
    hours
    paymentAmount
    paymentMethod
    paymentId
    description
    chargedBy
    removedAt
    createdAt
    updatedAt
    attachmentKey
    attachmentName
    homeServiceProvider {
      firstName
      lastName
    }
    chargedByOperator {
      firstName
      lastName
    }
  }
`);
